import { useEffect, useState } from "react";

/**
 * Barre de progression de lecture — fine, dorée, fixée en haut.
 * Se cache si prefers-reduced-motion (sinon transition douce).
 */
export default function ReadingProgress() {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const handler = () => {
      const doc = document.documentElement;
      const scrollTop = window.scrollY || doc.scrollTop;
      const maxScroll = (doc.scrollHeight - window.innerHeight);
      const p = maxScroll > 0 ? Math.min(100, (scrollTop / maxScroll) * 100) : 0;
      setPct(p);
    };
    handler();
    window.addEventListener("scroll", handler, { passive: true });
    window.addEventListener("resize", handler);
    return () => {
      window.removeEventListener("scroll", handler);
      window.removeEventListener("resize", handler);
    };
  }, []);
  return (
    <div className="fixed top-0 left-0 right-0 z-50 h-[3px] bg-transparent pointer-events-none" aria-hidden="true">
      <div
        data-testid="reading-progress"
        className="h-full bg-accent-brand transition-[width] duration-100 ease-out"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
